export const notasD2lKeys = {
  all: ['notasD2l'],
  lista: (hq, filtros) => ['notasD2l', 'lista', hq, filtros],
};

export default notasD2lKeys;
